import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
import productHomeowners from './product-homeowners.png'

export const meta: MetaFunction = () => [
	{ title: 'Homeowners Insurance' },
	{
		name: 'description',
		content: 'We offer insurance for homeowners.',
	},
]

const HomeownersProductPage = () => (
	<main className="mx-auto my-10 max-w-7xl">
		<Link to="/" prefetch="intent" className="text-blue-600 underline">
			Home
		</Link>{' '}
		&rarr;{' '}
		<Link to="/products/" className="text-blue-600 underline" prefetch="intent">
			Products
		</Link>
		<br />
		<br />
		<h1 className="py-3 text-4xl font-black">Homeowner's Insurance</h1>
		<img
			src={productHomeowners}
			alt="A home"
			className="rounded-lg object-cover object-center"
		/>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Farm owners and home owners originally banded together to share in the
			cost of insuring their properties. Everyone that wanted to participate in
			the group would join the group by buying a policy. At the end of the year
			the total amount of claim payments was calculated and the group members
			were assessed a premium based on their representative exposure to the
			group. These policies typically covered fire. Fire insurance gained in
			popularity and became more widely adopted.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			As it happened, there arose circumstances which caused significant
			financial loss in other areas besides fire. Some had trees blow over on to
			their house, or hail damage that destroyed a barn. Insurers found that
			there was a market demand for policies that would cover more types of
			claims than just fire.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Even the most basic policies today are much more advanced than the first
			policies that got the ball rolling for the property insurance industry.
			Now there are a myriad of choices when selecting a policy. Here is what
			you need to know about homeowner's insurance in order to make an informed
			decision:
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			1. What's The Form?
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Many companies have banded together to create standards to meet the
			interests of
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			a. standards bodies like your state department of financial services &
			insurance
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			b. insurance policyholders looking to make a comparison between companies
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			c. claims handling can be consistent when dealing with two companies that
			share a common form.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			There are a few levels of Base forms. A property insurance policy will use
			one base form that is the starting point for the entire insurance
			contract. You can add other forms on top of it. One way to visualize it is
			to think of it like a trip to the ice cream parlor. Some people prefer to
			keep it simple and order a single scoop of vanilla ice cream. The most
			simple homeowner's policy will be like that single vanilla scoop. You have
			a few options that can be added on top, like sprinkles. They are like
			additional forms that are added to the base form.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Here is a high level overview:
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Form 1 "Basic Form"
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			As the name implies, this form only covers the basics. Some basic form
			policies only cover fire damage.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Some people get two scoops of ice cream. They remind me of the people who
			want more out of their insurance program and who choose the Broad form
			(form 2). Like the basic form, you can add toppings in the form of extra
			policy forms that modify the insurance contract adding features and
			benefits that help the policy to respond to situations in a way that you
			prefer. Kind of like adding chocolate syrup.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			The best homes qualify for the banana split - the "special form" or form 3
			coverage. It stands above the other policies. Three scoops of ice cream
			over top of ripe split bananas. Chocolate syrup, peanuts, whipped cream,
			and even a cherry on top. The special form policy differs from forms 1 and
			2 in a key way. Forms 1 and 2 are called named perils policies. They ONLY
			cover the types of claims that are specifically listed on the policy. The
			special form is not a named peril policy. It is a different breed
			altogether, called a named exclusion policy. It covers all types of claims
			you might imagine! The policy does name a few types of claims that cannot
			be insured for. These are called exclusions. That's how this type of form
			earned its name. It names the exclusions in the policy. Unless the loss is
			listed in the list of exclusions, the insurer will agree that coverage
			applies. A list of common exclusions in special form policies is:
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			<ul>
				<li>
					Intentional Acts (you can't damage your home on purpose, or perform an
					action that a reasonable person would expect to cause damage to your
					home, and then expect the insurance company to pay for the damage)
				</li>
				<li>
					Flood (due to the complex nature of floods, this peril is excluded
					under a homeowner's policy and can be purchased separately with flood
					insurance)
				</li>
				<li>
					Earthquake (some insurers offer the option to add earthquake coverage
					to your policy)
				</li>
				<li>
					Animal Damage (damage caused by insects, birds, rodents, or even house
					pets)
				</li>
			</ul>
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			There are sub-limits on certain types of property. You will select a base
			form, coverage limit for the house, a valuation type (RC or ACV), & a
			deductible.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			How much coverage? How to choose the right limits (and what type?)
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			What's covered- perils and exclusions
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			An incomplete list of Coverage options - water backup, earthquake,
			Identity fraud, debris removal, mold, scheduled personal property
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			selecting a deductible
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Deductibles exist because insurance is designed for those infrequent,
			catastrophic financial losses that would occur in the absence of
			insurance. Some people treat it as a maintenance policy and instead of
			fixing small problems, they wait until small problems turn into big ones,
			and then expect the insurer to cover it. A deductible is a way for you to
			share in the cost of any losses and helps you have some skin in the game -
			an incentive to avoid placing small claims. The higher a deductible you
			choose, the lower the premium will be.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			In order to give policyholders options to reduce premiums and make
			insurance more affordable, they offer you the choice of one deductible out
			of several choices. I have found that many people make this determination
			without pausing to consider the financial impact that might result from
			their choice.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			For those that I have had the privilege of writing a new policy or
			reviewing an older one, many who stop to consider the alternatives
			actually opt to raise deductibles from $250 or $500 up to $1,000 or
			$2,500. Over the course of several years, they enjoy keeping a significant
			amount of premium in their pocket.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			How is my rate calculated?
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Protection from fire
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Dating back to the roots of property insurance, fire was one of the most
			destructive forces that property owners feared. Once started, a fire was
			very difficult to extinguish without some of the modern firefighting
			technology we have available today. In order to make insurance more
			affordable to those with the lowest risk of fire, one significant
			component that is used to offer different rates to different policyholders
			is the Fire Protection Class often referred to in short form as Protection
			Class.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			The short definition is that the closer you are to the fire department and
			a fire hydrant, the better. The distance (in miles) from a responding fire
			department and distance (in feet) from a fire hydrant are used together to
			determine the fire protection classification. It may also be dependent on
			the fire department's Paid/volunteer status, the ISO Rating of the fire
			department, the capabilities and limitations of their equipment and
			staffing. The construction material used to build your home also plays a
			part in the rate determination. Because brick homes have greater fire
			resistance, they are less expensive to insure than a wood frame home.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Insurance Score
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Insurers gather a significant amount of data so that the actuaries they
			employ can study it and gain insights about the characteristics that
			predict how much the insurer needs to charge to expect to be able to
			remain in business. The data shows a statistically significant correlation
			that those with better credit scores have comparatively fewer claims and,
			on average, the claims are smaller and easier to handle. Many companies
			have a credit-based scoring system that offers better rates to
			policyholders that have a better credit profile.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Claim / Loss history
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			If you have had one or more loss events, whether or not covered by, or
			paid for by insurance, you may find that your eligibility for a policy
			program or discount may be affected. With each subsequent claim in recent
			history (typically looking back 5 years or fewer), the likelihood of a
			rate or eligibility impact increases.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Some carriers are more lenient when considering a claim that is associated
			with a catastrophic loss event, also known as a CAT. During certain
			circumstances - specifically when a large number of policyholders are
			affected by an extreme weather event confined within a geographic area,
			the insurer deems losses caused by the weather conditions as a
			catastrophe. CAT losses are widely viewed as an unavoidable loss, and are
			treated accordingly. If you see an increase in the cost of your insurance,
			or if the ability to renew your policy becomes jeopardized as a result of
			claim frequency or severity, it is probably not related to the cat claim.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			special hazards
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Insurers use data collected about the expenses generated by claims in an
			effort to find ways to help policyholders maintain a safe environment
			where claims are unlikely. To this end, you may pay less for insurance if
			your home is free from common claim causes, include:
			<ul>
				<li>Trampoline</li>
				<li>Swimming pool</li>
				<li>Diving board</li>
				<li>Wood-burning stove</li>
				<li>Underground fuel tank</li>
				<li>Pets</li>
				<li>Business or farming on the premises</li>
			</ul>
			To be clear, each insurer establishes UNDERWRITING GUIDELINES - or the
			rules that must be followed in order for coverage to be valid. If you fail
			to follow the underwriting guidelines when setting up your policy, it
			could cause the policy to be cancelled or coverage to be denied. If you
			have a question about anything you feel may affect your eligibility for a
			policy program, it really is best to bring up the concern with your agent
			and the agent can confirm with the carrier underwriter whether or not you
			meet the requirements.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Naughty dogs and other hazards
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			There's a discount for that?
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			In the same way that a pool or trampoline could increase the likelihood of
			having certain types of claims, you will also find that you qualify for
			discounts based on safety features of your home. Ask your agent if you are
			receiving a credit on your premium for any of the following:
			<ul>
				<li>Smoke detectors</li>
				<li>Deadbolt locks</li>
				<li>Fire extinguisher</li>
				<li>Sprinkler System</li>
				<li>Burglar Alarm</li>
				<li>Freeze Alarm</li>
				<li>Water Damage Alarm</li>
				<li>Nonsmoking home</li>
			</ul>
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Self Assessment:
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When reading your policy, pay close attention to the list of covered
				perils and also the exclusions that apply to the coverage. If you see
				anything you don't understand, or if you feel a change is appropriate,
				it's important to notify your agent in writing. When you make this
				request, the agent should see if your request can be complied with and
				communicate with you. Ask yourself the following questions to make sure
				there will be no surprises:
				<ul>
					<li>
						Does the insurance policy include coverage for the types of claims I
						expect I might encounter?
					</li>
					<li>
						Have I researched common types of claims for my situation and
						compared the list with my policy to make sure I have considered all
						of the possibilities?
					</li>
					<li>
						Have I taken all safety precautions to reduce the likelihood of a
						preventable claim? What more should I be doing?
					</li>
					<li>
						Are there any discounts that are offered on the policy, that I am
						not currently taking advantage of?
					</li>
				</ul>
			</p>
		</p>
	</main>
)

export default HomeownersProductPage
